import { render, staticRenderFns } from "./EditApprentice.vue?vue&type=template&id=51d51478&"
import script from "./EditApprentice.vue?vue&type=script&lang=js&"
export * from "./EditApprentice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports